import { Client } from '../../pages/dashboard/Clients/types';

export const STORAGE_KEYS = {
    LAST_CLIENT: 'lastClientCode',
};

export function saveLastClientCode(clientCode: string | undefined): void {
    if (clientCode) {
        localStorage.setItem(STORAGE_KEYS.LAST_CLIENT, clientCode);
    }
}

export function saveLastClient(client: Client | null): void {
    if (client?.code) {
        localStorage.setItem(STORAGE_KEYS.LAST_CLIENT, client.code);
    } else {
        removeLastClientCode();
    }
}

export function getLastClientCode(): string | null {
    return localStorage.getItem(STORAGE_KEYS.LAST_CLIENT);
}

export function removeLastClientCode(): void {
    localStorage.removeItem(STORAGE_KEYS.LAST_CLIENT);
}
